import { FC } from 'react'
import { StyleProp, StyleSheet, Text, TextStyle } from 'react-native'
import { FontsEnum } from '../../constants/fonts'
import { useAppSelector } from '../../hooks/redux'
import { useTimeState } from '../../hooks/useTimeState'
import { selectLicense } from '../../redux/reducers/license'

interface ClockProps {
    style?: StyleProp<TextStyle>
}

const Clock: FC<ClockProps> = ({ style }) => {
    const license = useAppSelector(selectLicense)

    const time = useTimeState(
        () => new Date().toLocaleTimeString(license!.language).slice(0, -3),
        60000
    )

    return <Text style={[styles.time, style]}>{time}</Text>
}

const styles = StyleSheet.create({
    time: {
        color: '#FFFFFF',
        fontFamily: FontsEnum.RUBIK_700_BOLD,
        fontSize: 24,
    },
})

export default Clock
